export default __webpack_public_path__ + "static/media/audit6.cb416a09.png";